import React from 'react';
import { Link } from 'react-router-dom';
import { getLeadIntentCopy } from '../content/index.js';
import { formatDurationMonths, formatMoney } from '../utils/format.js';
import { useLeadModal } from './LeadModalProvider.jsx';
import CompareButton from './CompareButton.jsx';

export default function ProgramCard({
  to,
  slug,
  name,
  universityName,
  universitySlug,
  levelCode,
  mode,
  durationMonths,
  totalFeeMin,
  currency
}) {
  const { openLeadModal } = useLeadModal();
  const feesCopy = getLeadIntentCopy('fees');
  const preferredProgram = [name, universityName].filter(Boolean).join(' — ');
  const leadSource = `course_fees_${slug}`;
  const meta = [mode, durationMonths ? formatDurationMonths(durationMonths) : null]
    .filter(Boolean)
    .join(' • ');

  function handleGetFees(event) {
    event.preventDefault();
    event.stopPropagation();
    openLeadModal({
      intent: 'fees',
      leadSource,
      preferredProgram
    });
  }

  return (
    <article className="course-card">
      <Link to={to} className="course-card-main">
        <div className="course-card-top">
          {levelCode && <span className="pill">{levelCode}</span>}
          <h3>{name}</h3>
        </div>
        {meta ? <p className="course-meta">{meta}</p> : null}
        {totalFeeMin !== null && totalFeeMin !== undefined && (
          <p className="course-fee">From {formatMoney(totalFeeMin, currency)}</p>
        )}
        <span className="link-button">View course details →</span>
      </Link>
      <button
        type="button"
        className="cta-button course-card-fees lead-intent-btn"
        data-lead-intent="fees"
        data-lead-source={leadSource}
        data-lead-program={preferredProgram}
        onClick={handleGetFees}
      >
        {feesCopy.cta || 'Get course fees'}
      </button>
      <CompareButton
        course={{ slug, name, universityName, universitySlug, levelCode }}
      />
    </article>
  );
}
